import { useTheme } from '@emotion/react'
import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
import React, { useState } from 'react'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper'
import CustomTabs from 'ui-components/CustomTabs'
import { TabContext } from '@mui/lab'
import { Box, useMediaQuery } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { makeStyles } from '@mui/styles'
import OneTimePurchases from './OneTime'
import Subscriptions from './Subscriptions'

const useStyles = makeStyles((theme) => ({
  scrollTabs: {
    "&": { padding: "3rem" }
  }
}));

const tabs = [
  // { label: 'Subscriptions', value: 'subscriptions' },
  { label: 'One-Time Purchases', value: 'one-time' }
];

const OrdersAndInvoices = ({ value }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const classes = useStyles();
  const { tab } = useParams();

  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = React.useState(tab ?? value ?? 'one-time');

  const handleTabChange = (e, value) => {
    setLoading(true);
    setCount(null);
    setTabValue(value);
    navigate(`/orders-invoices/${value}`, { replace: true });
    setLoading(false);
  };

  return (
    <ThemeBGWrapper>
      <BreadcrumbHeader title={"Orders & Invoices"} sx={{ paddingBottom: "0 !important" }} Actions={() => <NeedHelpButton />} />

      <Box sx={{ padding: isSmallScreen ? "1rem" : "0rem 2rem" }}>
        <TabContext value={tabValue}>
          <CustomTabs
            data={tabs.map(item => ({
              ...item,
              label: `${item.label} ${tabValue === item.value && tabValue && count && count !== 0 && loading === false ? `(${count})` : ""}`
            }))}
            value={tabValue}
            sx={{ border: '0px solid black !important', paddingTop: '1rem' }}
            bgColor={"transparent"}
            allowScrollButtonsMobile={true}
            handleChange={handleTabChange}
            className={classes.scrollTabs}
          />
        </TabContext>
        {tabValue === "subscriptions"
          ? <Subscriptions setCount={setCount} setLoading={setLoading} />
          : <OneTimePurchases setCount={setCount} setLoading={setLoading} />
        }
      </Box>
    </ThemeBGWrapper>
  );
};

export default OrdersAndInvoices;
